(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markups = void 0;

var _projects = require("./projects.js");

var generateMarkup = function generateMarkup(project) {
  return "\n    <div class=\"portfolio__project\">\n    <div class=\"portfolio__image-box\">\n    <picture>\n        <source srcset=\"".concat(project.image, ".webp\" />\n        <img\n        src=\"").concat(project.image, ".jpg\"\n        alt=\"").concat(project.alt, "\"\n        title=\"").concat(project.alt, "\"\n        class=\"portfolio__image img-fluid\"\n        />\n    </picture>\n    </div>\n    <div class=\"portfolio__details-box\">\n    <p class=\"project-caption\">").concat(project.type, "</p>\n    <h4 class=\"heading-4 portfolio__project-title\">\n    ").concat(project.title, "\n    </h4>\n    ").concat(project.descriptionTwo ? "<p class=\"detail-paragraph\">\n                ".concat(project.description, "<span\n                id=\"dots\"\n                >...</span\n                >\n                <span class=\"read-more\">read more &darr;</span>\n            </p>\n            <p class=\"detail-paragraph collapsible\">\n                ").concat(project.descriptionTwo, "\n                <span class=\"read-less\">read less &uarr;</span>\n             </p>") : " <p class=\"detail-paragraph\">\n                ".concat(project.description, "\n            </p>"), "\n    \n    <ul class=\"technologies\">\n        ").concat(project.technologies.map(function (tech) {
    return "<li class=\"technologies__item ".concat(tech.toLowerCase(), "\">").concat(tech, "</li>");
  }).join(''), "\n    </ul>\n    <a\n        href=\"").concat(project.projectUrl, "\"\n        target=\"_blank\"\n        class=\"btn-primary\"\n        >View Project</a\n    >\n    </div>\n</div>\n    ");
};

var markups = _projects.projects.map(function (project) {
  return generateMarkup(project);
});

exports.markups = markups;

},{"./projects.js":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projects = void 0;
var projects = [{
  title: 'Forkify | Recipe application with custom recipe uploads',
  image: 'images/forkify',
  alt: 'Forkify Recipe Application',
  type: 'Application',
  description: "A thoroughly functional and elegant application that\n                   allows its user to search, bookmark, create recipes,\n                   and update the servings so they can get the recipe accordingly.",
  descriptionTwo: "Built with the MVC architecture and OOP which makes the app\n                      future-proof in terms of structure, maintainability, and\n                      expandability to easily add new features in the future.",
  technologies: ['HTML', 'CSS', 'JavaScript', 'SASS', 'API'],
  projectUrl: 'https://us-man-forkify.netlify.app/'
}, {
  title: 'TODO | Classic app with a few twists!',
  image: 'images/todo-app',
  alt: 'Todo Application',
  type: 'Application',
  description: "The sacred Todo application. A staple for every portfolio\n                    website. This one comes with a dark/light theme toggle.",
  descriptionTwo: "Also includes the more traditional features like adding,\n                    removing, and checking/unchecking tasks. Also, added 3 filter\n                    options for some good measures.",
  technologies: ['HTML', 'CSS', 'JavaScript'],
  projectUrl: 'https://us-man-todo.netlify.app/'
}, {
  title: 'Room | Discover innovative ways to decorate',
  image: 'images/room-homepage',
  alt: 'Room Website Homepage',
  type: 'Website',
  description: "E-commerce homepage for a furniture website. A Simplistic\n                    design with a beautiful slider that changes the hero image and\n                    the section's heading along with the content with a single\n                    click.",
  descriptionTwo: null,
  technologies: ['HTML', 'CSS', 'JavaScript', 'SASS'],
  projectUrl: 'https://usman-fe.github.io/room-homepage/'
}, {
  title: 'Easybank landing page',
  image: 'images/easybank-landing-page',
  alt: 'Easybank Landing Page',
  type: 'Website',
  description: "This beautiful landing page is built with Bootstrap 5 combined\n                    with SASS and a little bit of JavaScript. It has optimized\n                    images (using gulp-imagemin & gulp-webp). Also, this website\n                    is fully responsive.",
  descriptionTwo: null,
  technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'SASS'],
  projectUrl: 'https://us-man-easybank.netlify.app/'
}, {
  title: 'PIG Game | Multiplayer fun',
  image: 'images/pig-game',
  alt: 'Pig Game',
  type: 'GAME',
  description: "A wonderful Multiplayer dice rolling game that'll test your\n                    luck and your game approach to whether hold your points and\n                    wait for the next turn or just be brave and keep going. The\n                    first player to reach a hundred points wins.",
  descriptionTwo: null,
  technologies: ['HTML', 'CSS', 'JavaScript'],
  projectUrl: 'https://us-man-pig-game.netlify.app/'
}, {
  title: 'Nexter | The ultimate personal freedom',
  image: 'images/nexter',
  alt: 'Nexter Website',
  type: 'WEBSITE',
  description: "A gorgeous single page website. Made with CSS Grid and\n                    Flexbox, containing beautiful sections like image gallary and\n                    minimalist booking cards all completly responsive.",
  descriptionTwo: null,
  technologies: ['HTML', 'CSS', 'SASS'],
  projectUrl: 'https://us-man-nexter.netlify.app/'
}];
exports.projects = projects;

},{}],3:[function(require,module,exports){
"use strict";

var _portfolioView = require("./portfolioView.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// /////////////////////////////////////////////////////
// ///////////////// LOAD PORTFOLIO PROJECTS ////////////////////////////////////
// /////////////////////////////////////////////////////
var projectbox = document.querySelector('.portfolio__project-box');

_portfolioView.markups.forEach(function (markup) {
  return projectbox.insertAdjacentHTML('beforeend', markup);
}); // /////////////////////////////////////////////////////
// ///////////////// MODAL ////////////////////////////////////
// /////////////////////////////////////////////////////


var hamburger = document.querySelector('.header__hamburger');
var hamburgerIcon = document.querySelector('.header__hamburger-icon');
var backdrop = document.querySelector('.backdrop');
var navBox = document.querySelector('.header__nav');
var navList = document.querySelector('.header__nav-list');
var links = document.querySelectorAll('.header__nav-link');
hamburger.addEventListener('click', function () {
  backdrop.classList.toggle('backdrop-show');
  navBox.classList.toggle('header__nav--show');
  navList.classList.toggle('header__nav-list--show');
  hamburgerIcon.classList.toggle('header__hamburger-icon--toggle');
});
links.forEach(function (link) {
  link.addEventListener('click', function () {
    backdrop.classList.remove('backdrop-show');
    navBox.classList.remove('header__nav--show');
    navList.classList.remove('header__nav-list--show');
    hamburgerIcon.classList.remove('header__hamburger-icon--toggle');
  });
}); // /////////////////////////////////////////////////////
// ///////////////// ABOUT SECTION PARALLAX ////////////////////////////////////
// /////////////////////////////////////////////////////

var aboutParallex = document.getElementById('about');
var aboutParallexImg = document.getElementById('about-img');
var innerWidthMed = 720;
var innerWidthsmallest = 500;
var mediumCheck = window.innerWidth <= innerWidthMed;

var obsCallBack0 = function obsCallBack0(entries) {
  var _entries = _slicedToArray(entries, 1),
      entry = _entries[0];

  if (entry.isIntersecting && entry.intersectionRatio > 0) {
    if (entry.boundingClientRect.y < 0) return;
    aboutParallexImg.style.transform = 'translateY(250px)';
    var scroll1 = window.scrollY;
    window.addEventListener('scroll', function () {
      var value = 250 + (window.scrollY - scroll1) * "".concat(mediumCheck ? -0.5 : -0.35);
      aboutParallexImg.style.transform = "translateY(".concat(value, "px)");
    });
  }
};

var options0 = {
  root: null,
  threshold: 0,
  rootMargin: '50px'
};
var observer0 = new IntersectionObserver(obsCallBack0, options0);
observer0.observe(aboutParallex); // /////////////////////////////////////////////////////
// ///////////////// READ MORE / LESS ////////////////////////////////////
// /////////////////////////////////////////////////////

var btnColl = document.querySelectorAll('.read-more');
var btnLess = document.querySelectorAll('.read-less');
btnColl.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var content = this.parentElement.nextElementSibling;
    var dots = this.previousElementSibling;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      dots.style.display = 'inline';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      this.style.display = 'none';
      dots.style.display = 'none';
    }
  });
});
btnLess.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var content = this.parentElement;
    var dots = this.parentElement.previousElementSibling.querySelector('#dots');
    var readMore = this.parentElement.previousElementSibling.querySelector('.read-more');

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      dots.style.display = 'inline';
      readMore.style.display = 'inline';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      dots.style.display = 'none';
    }
  });
}); // /////////////////////////////////////////////////////
// ///////////////// PORTFOLIO IMAGE PARALLAX ////////////////////////////////////
// /////////////////////////////////////////////////////

var projects = Array.from(document.querySelector('.portfolio__project-box').children);

var obsCallBack = function obsCallBack(entries) {
  var _entries2 = _slicedToArray(entries, 1),
      entry = _entries2[0];

  if (entry.isIntersecting && entry.intersectionRatio > 0) {
    if (entry.boundingClientRect.y < 0) return;
    var portImg = entry.target.firstElementChild;
    portImg.style.transform = "translateY(".concat(mediumCheck ? 90 : 250, "px)");
    var scroll1 = window.scrollY;
    window.addEventListener('scroll', function () {
      var value = (mediumCheck ? 90 : 250) + (window.scrollY - scroll1) * (mediumCheck ? -0.15 : -0.35);
      portImg.style.transform = "translateY(".concat(value, "px)");
    });
  }
};

var options = {
  root: null,
  threshold: 0,
  rootMargin: '200px'
};
projects.forEach(function (project) {
  var observer = new IntersectionObserver(obsCallBack, options);
  observer.observe(project);
}); // /////////////////////////////////////////////////////
// ///////////////// PROGESS BAR ////////////////////////////////////
// /////////////////////////////////////////////////////
// /////////////////////////////////////////When the user scrolls the page, execute myFunction

window.onscroll = function () {
  myFunction();
};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = winScroll / height * 100;
  document.getElementById('myBar').style.width = scrolled + '%';
} // /////////////////////////////////////////////////////
// ///////////////// REVEAL SECTIONS ////////////////////////////////////
// /////////////////////////////////////////////////////


var allSections = document.querySelectorAll('.section');

var revealSection = function revealSection(entries, observer) {
  var _entries3 = _slicedToArray(entries, 1),
      entry = _entries3[0];

  if (!entry.isIntersecting) return;
  entry.target.classList.remove('section--hidden');
  observer.unobserve(entry.target);
};

var sectionObserver = new IntersectionObserver(revealSection, {
  root: null,
  threshold: 0.15
});
allSections.forEach(function (section) {
  sectionObserver.observe(section);
  section.classList.add('section--hidden');
});

},{"./portfolioView.js":1}]},{},[3]);
